<template>
	<div class="table-responsive">
		<table class="table" style="min-height: 250px !important;">
			<thead>
				<tr>
					<!-- <th>&nbsp;</th> -->
					<th>State</th>
					<th>Campaign</th>
					<th>Type</th>
					<th>Start Date</th>
					<th>End Date</th>
					<th>Daily Budget</th>
					<th>Group Name</th>
					<th class="text-center" style="width:10%">Actions</th>
				</tr>
			</thead>
			<tbody v-if='renderComponent'>
				<tr v-for="(item, k) in campaignList" :key="item.id">
					<!-- <td>&nbsp;</td> -->
					<td v-if ="item.ams_shutoff">
						<button class=" btn btn-primary" disabled=true  style="background-color:rgb(117, 199, 145)">AMSO</button>
					</td>

					<td v-else-if ="(item.ml_shutoff || item.midnight_shutoff)">
						<button v-if = "item.ml_shutoff" disabled=true class=" btn btn-primary" style="background-color:rgb(232, 210, 174)" >MLSO</button>
						<button v-if = "item.midnight_shutoff" disabled=true class=" btn btn-primary" style="background-color:rgb(255, 102, 153)">MNSO</button>
					</td>
					<td v-else>
						<button class=" btn btn-primary" disabled=true style="background-color:#3da3a7">Active</button>
					</td>
					<td>
						{{ item.name }}
						<span class="label label-info">Info Label</span>
					</td>
					<td style = "text-transform: capitalize">{{ (item.campaign_type ? item.campaign_type : 0) }}</td>
					<td>{{(item.start_date ? moment(item.start_date).format('L') : '' ) }}</td>
					<td>{{(item.end_date ? moment(item.end_date).format('L') : '' ) }}</td>
					<td>{{ (item.daily_budget ? item.daily_budget : 0) }}</td>
					<td v-if="item.campaignGroupName">{{ item.campaignGroupName }}</td>
					<td v-else><span style="color:#63B805">N/A</span></td>
					<td v-if= "multipleProduct" class="text-center">
						<button  type="button" class="btn btn-primary align-bottom" @click = "selectAddOrRemove(item)" v-if ="item.status == 'toAdd'">Add</button>
						<button  type="button" class="btn  btn-danger align-bottom" @click = "selectAddOrRemove(item)" v-if ="item.status == 'toRemove'">Remove</button>
						<button  type="button" class="btn btn-primary align-bottom" @click = "selectAddOrRemove(item)" v-if ="item.status == 'addRemove'">Add/Remove</button>

					</td>
					<!-- <td v-else class="text-center">
						<button class="btn btn-primary align-bottom" v-if="campaignListUploadStatus[k] && campaignListUploadStatus[k].uploaded == 'pending'"  @click="addProductsToCampaign(item, k)"><i class="fa fa-plus"></i> Add</button>
						<button class="btn btn-danger align-bottom" v-if="campaignListUploadStatus[k] && campaignListUploadStatus[k].uploaded == 'done'" @click="removeProductsFromCampaign(item, k)"><i class="fa fa-times"></i> Remove</button>
						<div class="spinner-border" v-if="campaignListUploadStatus[k] && campaignListUploadStatus[k].uploaded == 'uploading'" role="status"><span class="sr-only">Loading...</span></div>
					</td> -->
					<td v-else class="text-center">
						<button class="btn btn-primary align-bottom" v-if="campaignListStatus[item.campaign_id] && campaignListStatus[item.campaign_id].status == 'pending'"  @click="addProductsToCampaign(item, k)" style = "padding:8px"><i class="fa fa-plus"></i> Add</button>
						<button class="btn btn-danger align-bottom" v-if="campaignListStatus[item.campaign_id] && campaignListStatus[item.campaign_id].status == 'done'" @click="removeProductsFromCampaign(item, k)" style = "padding:7px"><i class="fa fa-times"></i> Remove</button>
						<div class="spinner-border" v-if="campaignListStatus[item.campaign_id] && campaignListStatus[item.campaign_id].status == 'uploading'" role="status"><span class="sr-only">Loading...</span></div>
					</td>

				</tr>
			</tbody>
		</table>
		<CannotDeletePopUp
			headerMsg = "Cannot Delete Campaign"
			deleteMessage = "Cannot Delete as Only one product in campaign"
			/>
		<AddCampaignToProductPopUp v-if = "isAddOrRemovePopUp" :data = "selectedItem" @closePopUp = "closePopUp" :productList="paramslist" @getNewDataAndClose = "getNewDataAndClose"/>
	</div>
</template>

<script>
import moment from 'moment';
import CannotDeletePopUp from '../product/CannotDeletePopUp.vue'
import AddCampaignToProductPopUp from './AddCampaignToProductPopUp.vue'
export default {
	name:'CampaignGridList',
	components : {
		CannotDeletePopUp,
		AddCampaignToProductPopUp
	},
	data() {
		return {
			campaignListUploadStatus:[],
			isAddOrRemovePopUp : false,
			multipleProduct : false,
			selectedItem : {},
			paramslist : [],
			campaignListStatus:{},
			renderComponent:true
		}
	},
	props: {
		campaignList: {
			type: Array
		}
	},

	mounted() {
		if(this.$route.params.products.includes('+')){
			this.multipleProduct = true
			this.initializeStatus()
		}
		else{
			this.multipleProduct = false
			this.initializeCampaignListStatus()
		}
	},
	watch: {
		campaignList() {
			this.initializeCampaignListStatus()
		}
	},
	computed: {
		productArray() {
			return this.$route.params.products.split('+')
		}
	},
	methods:{
		moment,
		forceRerender () {
			this.renderComponent = false;
			this.$nextTick (() => {
				this.renderComponent = true;
			});
		},
		closePopUp(){
			this.isAddOrRemovePopUp = false;
		},
		getNewDataAndClose(){
			this.isAddOrRemovePopUp = false;
			let payload = {
				vendorId : this.$route.params.vendorId,
				ams_profile_id : this.$route.params.brandId
			}
			this.$store.dispatch('campaign/getCampaignList',payload)
		},
		initializeCampaignListStatus() {
			let id  = [];
			let vm  = this;
			if(this.$route.params.products.includes('+')){
				id = this.$route.params.products.split('+')
			}
			else{
				id.push(this.$route.params.products)
			}
		//	this.campaignListUploadStatus = []
			for(let i=0; i<vm.campaignList.length; i++) {
				let status = {}
				let asins = (vm.campaignList[i].id ? vm.campaignList[i].id.split(',') : [])
				let added = [];
				id.map((response) => {
				added = asins.filter((res) => {
					 return	response == res
					})
				})

				if(added.length){
				   status.uploaded = 'done'
				}
				else{
					status.uploaded = 'pending'
				}
				vm.campaignListStatus[vm.campaignList[i].campaign_id] ={}
				vm.campaignListStatus[vm.campaignList[i].campaign_id].status = status.uploaded
				this.campaignListUploadStatus.push(status)
			}
			this.forceRerender()
			console.log(this.campaignListUploadStatus)
		},
		selectAddOrRemove(data){

			this.isAddOrRemovePopUp = true
			this.selectedItem = data
		},
		addProductsToCampaign(item, index) {
			 ;
			let vm = this
			this.campaignListUploadStatus[index].uploaded = 'uploading'
			this.campaignListStatus[item.campaign_id].status = 'uploading'
			let payloadObject = {}
			payloadObject['campaignId'] = item.campaign_id
			payloadObject['ams_campaign_id'] = item.ams_campaign_id
			payloadObject['ids'] = this.productArray
			this.$store.dispatch('campaign/addCampaignToProduct', { data: payloadObject}).then((res) => {
				this.campaignListUploadStatus[index].uploaded = 'done'
				this.campaignListStatus[item.campaign_id].status = 'done'
				this.$emit('getList')
			})
		},
		removeProductsFromCampaign(item, index) {
			 ;
			let vm = this
			let payloadObject = {}
			payloadObject['campaignId'] = item.campaign_id
			payloadObject['ams_campaign_id'] = item.ams_campaign_id
			payloadObject['ids'] = this.productArray
			payloadObject['action'] = 'unassign'
			this.campaignListUploadStatus[index].uploaded = 'uploading'
			this.campaignListStatus[item.campaign_id].status = 'uploading'
			this.$store.dispatch('campaign/removeProductsFromCampaign', { data: payloadObject}).then((res) =>{

				if(res == "Cannot Remove"){
					this.campaignListUploadStatus[index].uploaded = 'done'
					this.campaignListStatus[item.campaign_id].status = 'done'
					$('#cannotDelete').modal('show')
				}
				else{
					this.campaignListUploadStatus[index].uploaded = 'pending'
					this.campaignListStatus[item.campaign_id].status = 'pending'
					this.$emit('getList')
				}
			})

		},
		initializeStatus(){
			let list = this.$route.params.products.split('+')
			for(let i = 0; i<this.campaignList.length; i++){
				if(this.campaignList[i].id){
					let idList = this.campaignList[i].id.split(',')
					let flag = 0;
					for(let j=0; j<list.length; j++){
						for(let k=0; k<idList.length; k++){
							if(list[j] == idList[k]){
								flag ++;
								break;
							}
						}
					}
					if(flag == list.length){
						this.campaignList[i].status = "toRemove"
					}
					else if(flag == 0){
						this.campaignList[i].status = "toAdd"
					}
					else{
						this.campaignList[i].status = "addRemove"
					}
				//	if(idList.length == list.length){
				//	}
					// else{
					// 	this.campaignList[i].status = "addRemove"
					// }
				}
				else{
					this.campaignList[i].status = "toAdd"
				}
			}
		}
	}
}
</script>

<style lang="scss">
.add-product-wrap {
	cursor: pointer;
	color: white;
	background: green;
}
.table-responsive.label {
    display: inline;
    padding: .2em .6em .3em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em;
}
.table-responsive.label-info {
    background-color: #5bc0de;
}

</style>
